import React from 'react';
import { OrangeButton } from 'components/Button';
import { CircularProgress, useMediaQuery } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';

const NextButton = (props: {
  isLoading: boolean;
  isLoadingParams: boolean;
  isComplementaryForm?: boolean;
}) => {
  const isNotMobile = useMediaQuery('(min-width:960px)');
  const nextButtonWidth = isNotMobile ? 100 : 230;
  const intl = useIntl();
  const { submitForm, errors, values } = useFormikContext<any>();
  return (
    <OrangeButton
      variant="contained"
      color="secondary"
      style={{ width: nextButtonWidth }}
      onClick={submitForm}
      disabled={
        Object.keys(errors).length > 0 ||
        props.isLoading ||
        props.isLoadingParams ||
        (props.isComplementaryForm &&
          values.dateNaissance === '' &&
          values.genre === '' &&
          values.nom === '' &&
          values.prenom === '')
      }
    >
      {props.isLoading || props.isLoadingParams ? (
        <CircularProgress size={20} />
      ) : (
        intl.formatMessage({ id: 'signup_auth_button.next' })
      )}
    </OrangeButton>
  );
};

export default NextButton;
